import React from 'react';

const LinkImage = ({ linkSrc, imageSubtitle, imageSrc, imageAlt }) => {
	if (typeof linkSrc === 'undefined') {
		return (
			<React.Fragment>
				<img src={imageSrc} alt={imageAlt} />
				{typeof imageSubtitle !== 'undefined' && <i>{imageSubtitle}</i>}
			</React.Fragment>
		);
	} else if (
		(typeof linkSrc !== 'undefined' && linkSrc.includes('https://')) ||
		linkSrc.includes('http://')
	) {
		return (
			<a href={linkSrc} target='_blank' rel='noopener noreferrer' target={'_blank'}>
				<img src={imageSrc} alt={imageAlt} />
				{typeof imageSubtitle !== 'undefined' && <i>{imageSubtitle}</i>}
			</a>
		);
	} else if (
		(typeof linkSrc !== 'undefined' && !linkSrc.includes('https://')) ||
		!linkSrc.includes('http://')
	) {
		return (
			<Link to={imageLink}>
				<img src={imageSrc} alt={imageAlt} />
				{typeof imageSubtitle !== 'undefined' && <i>{imageSubtitle}</i>}
			</Link>
		);
	} else {
		return (
			<React.Fragment>
				<img src={imageSrc} alt={imageAlt} />
				{typeof imageSubtitle !== 'undefined' && <i>{imageSubtitle}</i>}
			</React.Fragment>
		);
	}
};

export default LinkImage;
